import { render, staticRenderFns } from "./VCDateTimePicker.vue?vue&type=template&id=2bd98b23&scoped=true&"
import script from "./VCDateTimePicker.vue?vue&type=script&lang=ts&"
export * from "./VCDateTimePicker.vue?vue&type=script&lang=ts&"
import style1 from "./VCDateTimePicker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd98b23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
